<style>
  #report-besikt-list .input-container {
    margin-bottom: 0;
  }
</style>
<template>
  <div id="report-besikt-list" class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">{{title}}</h4>
      </div>

      <TheAutoCompleteInput v-model.trim="auctionCode" ref="auksjon_input" style="margin-right: 1rem;" containerClassName="cell large-4" name="Auksjon" maxlength="10" :placeholder="'Velg auksjon'" :label="''" :onInputCallback="onAuksjonSearchInput" :onSelectCallback="onAuksjonSearchSelected" :debounce="750" :minquery="2">
        <div slot="item" slot-scope="props">
          <strong>{{props.item.Auksjon}}</strong>, {{props.item.Beskrivelse}}
          <span v-if="props.item.Auksjon_dato">
            ({{ props.item.Auksjon_dato | avantidate }})
          </span>
        </div>
      </TheAutoCompleteInput>

      <div class="cell shrink">
        <a href="javascript:;" class="button primary" v-if="submitStatus === 'submittable'" @click="onReloadClick()">Last inn</a>
        <a href="javascript:;" class="button primary loading" v-else-if="submitStatus === 'loading'">Last inn <span class="loader-spinner"></span></a>
        <a href="javascript:;" class="button primary" disabled v-else>Last inn</a>

        <a v-if="submitStatus === 'loading'" class="button action glyph glyph-only small disabled">
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg>
          <span>Eksportere</span>
        </a>
        <a v-else class="button action glyph glyph-only small" :class="{'loading': submitStatus === 'exporting'}" @click="onExportClick()">
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg>
          <span class="loader-spinner"></span>
          <span>Eksportere</span>
        </a>

        <a v-if="submitStatus === 'processing'" class="button primary transparent" style="color: #bbb; cursor: not-allowed;">Gå tilbake</a>
        <router-link v-else :to="{ name: 'ReportsList' }" class="button primary transparent" >Gå tilbake</router-link>
      </div>
    </div>

    <div class="content-container flex-row">
      <router-view v-on:onSubmitStatusChange="onSubmitStatusChange"></router-view>
    </div>
  </div>
</template>

<script>
import AuksjonService from '@/services/AuksjonService'
import TheAutoCompleteInput from '../../Inputs/TheAutoCompleteInput'
import bus from '@/plugins/event-bus'

export default {
  name: 'Besiktigelse',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInput
  },
  data () {
    return {
      submitStatus: null,
      auctionCode: null,
      searchedAuctionCode: null
    }
  },
  computed: {
    title: function () {
      let retval = this.$route.meta.title || 'Rapporter - Besiktigelse - Email'

      if (this.searchedAuctionCode) {
        retval += ' (Auksjon: ' + this.searchedAuctionCode.toUpperCase() + ')'
      }

      return retval
    }
  },
  methods: {
    onAuksjonSearchInput: function (query) {
      return AuksjonService.search(query)
    },
    onAuksjonSearchSelected: function (item) {
      if (item) {
        this.auctionCode = item.Auksjon || ''
      }
    },
    onSubmitStatusChange: function (status) {
      this.submitStatus = status
    },
    onReloadClick: function () {
      const code = this.auctionCode ? this.auctionCode.toUpperCase() : null
      if (code) {
        this.searchedAuctionCode = code
        bus.$emit('reload-besiktigelselist', code)
      }
    },
    onExportClick: function () {
      const code = this.auctionCode ? this.auctionCode.toUpperCase() : null
      if (code) {
        this.searchedAuctionCode = code
        bus.$emit('export-besiktigelselist', code)
      }
    }
  }
}
</script>
<style scoped>
  input.uppercase {
    text-transform: uppercase;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Reports/Besiktigelse.vue